import { render, staticRenderFns } from "./Seatmap2.vue?vue&type=template&id=8636838c&scoped=true&"
import script from "./Seatmap2.vue?vue&type=script&lang=js&"
export * from "./Seatmap2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8636838c",
  null
  
)

export default component.exports